import { Theme } from '@mui/material';

const ANCHOR_GAP = 0.5;
const POPOVER_ALIGNMENT_OFFSET = 1;
const DROPDOWN_ALIGNMENT_OFFSET = 0.5;

interface AnchoredPaperSpacingParams {
  variant: 'popover' | 'dropdown';
  horizontal?: 'left' | 'right';
}

export const getAnchoredPaperSpacing =
  ({ variant, horizontal = 'right' }: AnchoredPaperSpacingParams) =>
  (theme: Theme) => {
    const alignmentOffset = theme.spacing(
      variant === 'popover' ? POPOVER_ALIGNMENT_OFFSET : DROPDOWN_ALIGNMENT_OFFSET,
    );

    return {
      marginTop: theme.spacing(ANCHOR_GAP),
      marginLeft: horizontal === 'right' ? alignmentOffset : `-${alignmentOffset}`,
    };
  };
